export default __webpack_public_path__ + "static/media/cinemaholic_logo.ca9a86b2.png";